import { useEffect } from 'react';

import {
  MoneybuysWrapper,
  MoneybuyLabel,
  MoneybuyRadioButton,
} from './Moneybuys.style';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { updatePaymentSelectFields } from '@/features/paymentSelect/paymentSelectSlice';

import { MoneybuysProps, IndividualMoneybuy } from './types';

function Moneybuys({
  isPayin,
  thisJourneysMoneybuys,
  currentAmount,
  currencySymbol,
  updateCallback,
}: MoneybuysProps) {
  const dispatch = useAppDispatch();
  const paymentSelectState = useAppSelector(state => state.paymentSelect);

  const changeMoneybuy = (
    thisMoneybuy: IndividualMoneybuy,
    thisIndex: number
  ) => {
    // Update the state with our chosen Moneybuy amount:
    dispatch(
      updatePaymentSelectFields({ amount: thisMoneybuy.amount })
    );
    // And where in the moneybuy index this one sits
    dispatch(updatePaymentSelectFields({ currentMoneybuyPosition: thisIndex }));

    // Revalidate form
    updateCallback();
  };

  // When the 'amount' field changes, see if it correlates with any of the MBs' amounts:
  useEffect(() => {
    // Keep a handy array of every amount for this journey type:
    const availableAmounts = thisJourneysMoneybuys?.map(item => item.amount);
    // See if we've got a match for the current 'amount' field amount:
    const thisIndex = availableAmounts.findIndex(
      thisAmount => thisAmount === currentAmount
    );
    // Use the index if we've got a match, else reset it:
    dispatch(
      updatePaymentSelectFields({ currentMoneybuyPosition: thisIndex ?? null })
    );
  }, [currentAmount, dispatch, thisJourneysMoneybuys]);

  return (
    thisJourneysMoneybuys && (
      <MoneybuysWrapper>
        {!isPayin && (
          <>
            {Object.entries(thisJourneysMoneybuys ?? []).map(
              ([key, thisMoneybuy], index) => {
                const isSelected = paymentSelectState.currentMoneybuyPosition !== null
                && paymentSelectState.currentMoneybuyPosition === index;

                return (
                  <MoneybuyLabel
                    key={key}
                    htmlFor={thisMoneybuy?.amount.toString()}
                    selected={isSelected}
                  >
                    <MoneybuyRadioButton
                      type="radio"
                      name="giving-type"
                      id={thisMoneybuy?.amount.toString()}
                      value={thisMoneybuy?.amount}
                      onChange={() => changeMoneybuy(thisMoneybuy, index)}
                      checked={isSelected ?? null}
                      data-moneybuy={index + 1}
                    />
                    {currencySymbol}
                    {thisMoneybuy?.amount}
                  </MoneybuyLabel>
                );
              }
            )}
          </>
        )}
      </MoneybuysWrapper>
    )
  );
}

export default Moneybuys;
